import { render, staticRenderFns } from "./UserAwardLog.vue?vue&type=template&id=72aafade&scoped=true&"
import script from "./UserAwardLog.vue?vue&type=script&lang=js&"
export * from "./UserAwardLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aafade",
  null
  
)

export default component.exports